import { useQuery } from "@tanstack/react-query";

import { journalSupportsApi } from "@/api";
import { QueryKey } from "@/query/Query";

export function useActiveJournalSupports() {
  const { data, isLoading } = useQuery({
    queryKey: [QueryKey.JournalSupports],
    queryFn: () => journalSupportsApi.getActiveJournalSupports(),
  });

  const active = data ?? [];
  const currentUserActive = active.find((e) => e.isCurrentUser) ?? null;

  return { active, currentUserActive, isLoading };
}
